export const ADMIN_USER_TYPE = [
  { value: 'true', label: 'Admin' },
  { value: 'false', label: 'Staff' },
];

export const ADMIN_USER_ACTIVE_TYPE = [
  { value: 'true', label: 'Active' },
  { value: 'false', label: 'Inactive' },
];

export const PERMISSION_LABELS = {
  0: 'None',
  1: 'View',
  2: 'Manage',
  3: 'All',
};

export const PERMISSION_OPTIONS = [
  { value: 0, label: 'None' },
  { value: 1, label: 'View' },
  { value: 2, label: 'Manage' },
  { value: 3, label: 'All' },
];
